import { ContactType } from '@/domain/ecommerce-contact'

const KEY_BY_TYPE: Record<ContactType, string> = {
  CUSTOMER_SERVICE: 'customer_service',
  LOGISTICS: 'logistics',
  INVOICING: 'invoicing',
  TECHNICAL_SUPPORT: 'technical_support',
  COMMERCIAL: 'commercial'
}

export function contactTypeLabelKey(type: ContactType) {
  return `dashboard_users.contact_type_${KEY_BY_TYPE[type]}`
}
